import * as React from 'react';
import { SVGProps } from 'react';

const IconFolderContourSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 1.7A.7.7 0 0 1 .7 1h5.886a1 1 0 0 1 .707.293l1.414 1.414A1 1 0 0 0 9.414 3H13a1 1 0 0 1 1 1v8.3a.7.7 0 0 1-.7.7H1a1 1 0 0 1-1-1V1.7Z"
      fill="var(--color-bg-caution)"
    />
    <path
      d="M0 3.7A.7.7 0 0 1 .7 3H13a1 1 0 0 1 1 1v8.3a.7.7 0 0 1-.7.7H1a1 1 0 0 1-1-1V3.7Z"
      fill="var(--color-bg-warning)"
    />
    <path
      d="M7.5 6.594a.2.2 0 0 1 .284-.182l2.695 1.244-2.979.71V6.595Z"
      fill="#EBEEEF"
      stroke="var(--color-typo-primary)"
    />
    <path
      d="M15.5 6.885a.2.2 0 0 0-.246-.195l-8.37 1.981a.5.5 0 0 0-.384.487v4.957a.2.2 0 0 0 .246.195l8.37-1.981a.5.5 0 0 0 .384-.487V6.885Z"
      fill="var(--color-bg-ghost)"
    />
    <path
      d="M15.5 6.885a.2.2 0 0 0-.246-.195l-8.37 1.981a.5.5 0 0 0-.384.487v4.957a.2.2 0 0 0 .246.195l8.37-1.981a.5.5 0 0 0 .384-.487V6.885Z"
      fill="#EBEEEF"
    />
    <path
      d="M15.5 6.885a.2.2 0 0 0-.246-.195l-8.37 1.981a.5.5 0 0 0-.384.487v4.957a.2.2 0 0 0 .246.195l8.37-1.981a.5.5 0 0 0 .384-.487V6.885Z"
      stroke="var(--color-typo-primary)"
    />
    <path
      d="M7 10.497c.072-.05.162-.115.296-.204.267-.178.65-.421 1.117-.682C9.347 9.09 10.627 8.492 12 8.2c1.374-.293 2.186-.139 2.663.122.142.078.252.164.337.248v1.15c0-.122-.148-.397-.272-.531a1.328 1.328 0 0 0-.391-.317c-.357-.195-1.045-.355-2.337-.08-1.294.274-2.513.841-3.413 1.343-.45.25-.816.484-1.07.654-.18.12-.394.276-.517.387v-.68Z"
      fill="var(--color-bg-warning)"
    />
    <path
      d="M10 10.023c-2.667.567-3 1.879-3 1.879v.827c1-.557 2.333-1.53 4.667-2.026 1.666-.354 2.777.1 3.333.326V10.2s-2.333-.745-5-.178Z"
      fill="var(--color-bg-normal)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m6.968 13.556-.105-.267-.105-.266.003-.002.004-.003.012-.008.045-.026a3.81 3.81 0 0 1 .167-.09c.147-.076.368-.18.674-.303.61-.243 1.559-.557 2.929-.848a23.355 23.355 0 0 1 3.258-.469 14.786 14.786 0 0 1 1.13-.033l.062.001.016.001h.006L15 11.56c-.015.069.018.308 0 .312-.019.005-.084-.015-.111.004-.05-.001-.15-.004-.249-.004-.197.002-.488.01-.864.034-.752.051-1.841.173-3.183.458-1.342.286-2.258.59-2.834.82-.287.115-.49.21-.618.277a3.166 3.166 0 0 0-.167.092l-.11.04.105-.037Z"
      fill="var(--color-bg-alert)"
    />
    <path
      d="m11 7.241 2.853 1.407c.495.245.897.89.897 1.443v4.594c0 .552-.402.802-.897.557L11 13.835V7.241Z"
      fill="#CCD9E0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m6.688 7.653-.179-.398-.179-.399h.003l.006-.002.024-.004.086-.013c.075-.01.183-.023.322-.035a8.4 8.4 0 0 1 1.16-.01c.968.055 2.236.157 3.67.863 1.44.71 2.362 1.694 2.865 2.424.12.175.218.34.298.49-.005.033-.005.766-.005 1.132 0 0-.34-.714-.738-1.291-.356-.518-1.092-1.32-2.403-1.966-1.317-.65-2.514-.796-3.437-.85a7.94 7.94 0 0 0-1.096.011 5.3 5.3 0 0 0-.374.044l-.018.003h-.004v.001Z"
      fill="var(--color-bg-warning)"
      style={{
        mixBlendMode: 'multiply',
      }}
    />
    <path
      d="M9.584 8.596c-2.75-1.357-3.084.273-3.084.273v1.099c1.031.05 2.38-.227 4.787.96 1.71.843 2.88 2.354 3.455 3.098l.008.01v-1.099s-2.416-2.985-5.166-4.341Z"
      fill="var(--color-bg-normal)"
      style={{
        mixBlendMode: 'multiply',
      }}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m6.647 11.469-.147-.402-.148-.402h.07c.04.003.098.007.174.016.153.02.38.06.694.142.627.166 1.586.412 2.981 1.1 1.396.689 2.541 1.48 3.33 2.01a22.568 22.568 0 0 1 1.155.828l.064.05.018.014.005.004h.001v.001l-.094.305-.095.305-.002-.002-.013-.01a21.49 21.49 0 0 0-1.147-.826c-.758-.508-1.867-1.234-3.222-1.902-1.354-.668-2.266-.939-2.843-1.092a4.725 4.725 0 0 0-.616-.126 1.717 1.717 0 0 0-.162-.013h-.004.001Z"
      fill="var(--color-bg-alert)"
      style={{
        mixBlendMode: 'multiply',
      }}
    />
    <path
      d="m11.448 7.963 2.405 1.185a.879.879 0 0 1 .449.722v4.594c0 .276-.201.4-.449.278l-2.405-1.185V7.963Z"
      stroke="var(--color-typo-primary)"
    />
  </svg>
);
export default IconFolderContourSizeS;
